import React, {useEffect, useState} from "react";
import {Box, Button, Dialog, DialogContent, Grid, IconButton, Stack, Typography} from "@mui/material";
import questionType from "../assets/data/typeMap";
import {QuestionSwitch} from "./Questions/QuestionSwitch";
import {firestore} from "../firebase/clientApp";
import {useParams} from "react-router-dom";
import {Close} from "@mui/icons-material";
import pleshDark from "../theme/pleshDark";
import { useTranslation } from 'react-i18next';
import useLanguageStore from "../store/languageStore";
import { getTranslatedText } from "../functions/getTranslatedText";
import {THEME_CONFIG} from "../config";


export const PinnedQuestions = ({questions}) => {
  const {primary} = THEME_CONFIG
  const { t } = useTranslation('components');

  const [selected, setSelected] = useState('')
  const {eventOwnerId, id} = useParams()

  const [elementPlaying, setElementPlaying] = useState({})
  const { currentLanguage, defaultLanguage } = useLanguageStore();

  useEffect(() => {
    selected !== '' ? getElementPlaying() : setElementPlaying({})
  }, [selected]);

  function getElementPlaying() {
    firestore.collection(`users/${eventOwnerId}/events/${id}/queue`).doc(selected).onSnapshot(s => {
      setElementPlaying({...s.data(), id: s.id})
      return s.data()
    })
  }

  return (
    <Box mt={3}>
      {selected !== '' &&
        <Dialog open={selected !== ''} onClose={() => setSelected('')} maxWidth={'md'}
                fullWidth={true}
                fullScreen={elementPlaying.tipo === 'color'}
        >
          <Box p={1} id={'a' + selected} /*id={'pinnedQuestionDialogBg'}*/>
            <Box sx={{textAlign: 'right'}}>
              <IconButton onClick={() => setSelected('')}
                          sx={{
                            color: elementPlaying.tipo === 'color' ? pleshDark.palette.getContrastText(elementPlaying.color) : ''
                          }}
              >
                <Close/>
              </IconButton>
            </Box>
            <Typography gutterBottom textAlign={'center'} variant={'h4'} fontWeight={'bold'}
                        sx={{color: elementPlaying.tipo === 'color' ? pleshDark.palette.getContrastText(elementPlaying.color) : ''}}
            >
              {getTranslatedText(elementPlaying.domanda, elementPlaying.domandaTranslations, currentLanguage, defaultLanguage)}
            </Typography>
            {questionType[elementPlaying.tipo]?.description &&
              <Typography gutterBottom textAlign={'center'} variant={'body2'} fontWeight={'light'}
                         sx={{color: elementPlaying.tipo === 'color' ? pleshDark.palette.getContrastText(elementPlaying.color) : ''}}
              >
                {questionType[elementPlaying.tipo]?.description}
              </Typography>}
            <QuestionSwitch elementPlaying={elementPlaying}/>
          </Box>
        </Dialog>}
      <Grid container justifyContent={'center'} width={'100%'}/* spacing={1}*/>
        {
          questions.docs?.length > 0 ?
            questions.docs?.sort((a, b) => a.data().position - b.data().position).map((button, i) => {
                return <Grid key={button.id} item xs={3.5} sx={{cursor: 'pointer'}}
                             onClick={() => setSelected(button.id)}
                >
                  <Box mb={1} mx={1} position={'relative'}>
                    <Box sx={{background: 'rgba(0,0,0,0.5)', width: '100%', border: '2px solid '+primary}}
                         minHeight={'105px'}
                         borderRadius={'18px 0'}>
                      <Box sx={{position: 'absolute', top: !!questionType[button.data().tipo]?.img ? '20%' : '20%', left: 0, right: 0}}>
                        {questionType[button.data().tipo]?.img}
                      </Box>
                    </Box>
                    <Box sx={{
                      background: pleshDark.palette.accent.main,
                      width: '100%',
                      position: 'absolute',
                      bottom: 0
                    }}
                         minHeight={'28px'}
                         borderRadius={'0 0 18px'}>
                      <Typography variant={'caption'} fontStyle={'italic'} fontWeight={'bold'}
                                  textTransform={'none'} color={'white'}>
                        {getTranslatedText(button.data().domanda, button.data().domandaTranslations, currentLanguage, defaultLanguage)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              }
            )
            :
              <Typography textAlign={'center'} fontSize={'1rem'} fontWeight={'bold'}>
                {t('pinnedQuestions.waitHere')} <br/>
                {t('pinnedQuestions.nextInteractionSoon')}
              </Typography>
        }
      </Grid>
    </Box>
  )
}